{"idealCurrency":"USD","idealLanguage":"en","idealLocation":"United States","idealCountry":"US"}